import { render, staticRenderFns } from "./PatientRecommendations.vue?vue&type=template&id=2c751212&scoped=true"
import script from "./PatientRecommendations.vue?vue&type=script&lang=js"
export * from "./PatientRecommendations.vue?vue&type=script&lang=js"
import style0 from "./PatientRecommendations.vue?vue&type=style&index=0&id=2c751212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c751212",
  null
  
)

export default component.exports